import { render, staticRenderFns } from "./areaRecordingWeeks.vue?vue&type=template&id=51e44208&scoped=true&"
import script from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"
export * from "./areaRecordingWeeks.vue?vue&type=script&lang=js&"
import style0 from "./areaRecordingWeeks.vue?vue&type=style&index=0&id=51e44208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e44208",
  null
  
)

export default component.exports